<script setup>
import { ref } from 'vue';
import MerchantGenerationProgressBar from '@/Components/Npcs/MerchantGenerationProgressBar.vue';

const props = defineProps({
    influence: {
        type: String,
        default: '',
    },
    edition: {
        type: String,
        default: '5e',
    },
});

const progressBarRef = ref(null);

function startProgress() {
    progressBarRef.value?.startProgress();
}

function completeProgress() {
    progressBarRef.value?.completeProgress();
}

function resumeProgress(elapsedSeconds) {
    progressBarRef.value?.resumeProgress(elapsedSeconds);
}

function resetProgress() {
    progressBarRef.value?.resetProgress();
}

defineExpose({
    startProgress,
    resumeProgress,
    completeProgress,
    resetProgress,
});
</script>

<template>
    <li class="border-b border-gray-500 last:border-b-0">
        <div class="block">
            <div class="flex items-center px-4 py-4 sm:px-6 relative">
                <div class="flex min-w-0 flex-1 items-start">
                    <!-- Image placeholder with shimmer -->
                    <div class="skeleton-shimmer rounded-lg bg-gray-700 flex-shrink-0" style="width: 8rem; height: 8rem;"></div>

                    <!-- Text placeholders + progress bar -->
                    <div class="flex-1 min-w-0 px-4 flex flex-col" style="height: 8rem;">
                        <div class="flex items-center gap-4 overflow-hidden flex-1">
                            <div>
                                <!-- Name placeholder -->
                                <div class="skeleton-shimmer rounded bg-gray-600 h-4 w-32 mb-1.5"></div>
                                <!-- Race placeholder -->
                                <div class="skeleton-shimmer rounded bg-gray-600 h-3.5 w-24 mb-1"></div>
                                <!-- Class placeholder -->
                                <div class="skeleton-shimmer rounded bg-gray-600 h-3.5 w-20"></div>
                            </div>
                            <div class="flex-1 overflow-hidden min-[420px]:block hidden" style="margin-left: auto">
                                <p v-if="props.influence" class="text-sm text-gray-400 italic line-clamp-3">"{{ props.influence }}"</p>
                            </div>
                        </div>

                        <!-- Progress bar at the bottom of the card -->
                        <div class="pb-1">
                            <MerchantGenerationProgressBar ref="progressBarRef" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<style scoped>
@keyframes skeleton-shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
}

.skeleton-shimmer {
    background: linear-gradient(
        90deg,
        rgba(55, 65, 81, 1) 25%,
        rgba(75, 85, 99, 1) 50%,
        rgba(55, 65, 81, 1) 75%
    );
    background-size: 200% 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
}
</style>
